import { setPageContent } from '..'
import { locale } from '../locale'
import { Bulma } from './bulma'
import { centeredBox } from './components'
import { Html } from './html'

/**
 * @type {import('navigo').Handler}
 */
function mount(ctx) {
    const uri = ctx && ctx.params && ctx.params.uri ? ctx.params.uri : "/devices"

    setPageContent(centeredBox("small",
        Bulma.title(locale.string({
            enGB: "Redirecting to app...",
            deDE: "Wird zur App weitergeleitet...",
            frFR: "Redirige vers l'application...",
            svSE: "Omdirigerar till appen...",
        }), "is-6")
    ))

    timeout = setTimeout(redirect(uri), 100)
}

function onUnmount() {
    clearTimeout(timeout)
}

/**
 * @param {string} uri 
 */
function redirect(uri) {
    return () => {
        const a = Html.anchor({
            href: uri,
        })
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }
}

export const redirectPage = {
    mount,
    onUnmount,
}

/** @type {NodeJS.Timeout} */
let timeout
